module.exports = __webpack_public_path__ + "img/4.33805b5a.webp";